import { QueryParam } from "../../../types/api/generic.type";
import {
  GetPotentialMatrixDevelopmentCalibrationSpeakerFollowResponse,
  GetPotentialMatrixDevelopmentCalibrationSpeakersResponse,
} from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixDevelopmentCalibrationService = {
  async getSpeakersList(
    pageSize: number,
    pageNumber: number,
    queryParams: QueryParam[],
  ): Promise<GetPotentialMatrixDevelopmentCalibrationSpeakersResponse> {
    const params = createQueryParamString(queryParams);
    const response =
      await httpClient.get<GetPotentialMatrixDevelopmentCalibrationSpeakersResponse>(
        `v1/potential-matrix-development/calibration/speakers?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      );
    return response;
  },
  async getSpeakerFollowList(
    speakerId: number,
    queryParams: QueryParam[],
  ): Promise<GetPotentialMatrixDevelopmentCalibrationSpeakerFollowResponse> {
    const params = createQueryParamString(queryParams, true);
    const response =
      await httpClient.get<GetPotentialMatrixDevelopmentCalibrationSpeakerFollowResponse>(
        `v1/potential-matrix-development/calibration/speakers/${speakerId}/follow${params}`,
      );
    return response;
  },
  async update(
    collaboratorId: number,
    queryParams: QueryParam[],
  ): Promise<void> {
    const params = createQueryParamString(queryParams, true);
    await httpClient.put(
      `v1/potential-matrix-development/calibration/collaborators/${collaboratorId}/confirm${params}`,
    );
  },
};

export default PotentialMatrixDevelopmentCalibrationService;
